import { render, staticRenderFns } from "./LandingPage.html?vue&type=template&id=6f5630f0&scoped=true&"
import script from "./LandingPage.js?vue&type=script&lang=js&"
export * from "./LandingPage.js?vue&type=script&lang=js&"
import style0 from "./LandingPage.scss?vue&type=style&index=0&id=6f5630f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5630f0",
  null
  
)

export default component.exports